<template>
  <div class="m-bottom">
    <ul class="bt-doc">
      <li>
        <router-link class="doc-link" to="/mterms">Terms</router-link>
      </li>
      <li>
        <router-link class="doc-link" to="/mprivacy">Privacy Policy</router-link>
      </li>
      <li>
        <img src="@/assets/img/email.png" alt="" class="email" />
        <span class="email-label">help.blueridge@blueridgemfb.com</span>
      </li>
    </ul>
    <ul class="bt-icon">
      <li class="twi">
        <img src="@/assets/img/google.png" alt="" />
        <img src="@/assets/img/twwiner.png" alt="" />
        <img src="@/assets/img/facebook.png" alt="" />
      </li>
      <li class="bt-logo">
        <img src="@/assets/img/logo-new.png" alt="" class="m-logo" />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="scss">
.m-bottom {
  background-color: #061227;
  padding: 20px 60px 60px;
  overflow: hidden;
  display: flex;
  .bt-doc {
    float: left;
    width: 840px;
    & > li {
      height: 66px;
      margin-bottom: 40px;
      .doc-link {
        color: #fff;
        font-size: 32px;
      }
      .email {
        width: 48px;
        margin-right: 16px;
        vertical-align: middle;
        // margin-top: -5px;
      }
      .email-label {
        color: #fff;
        font-size: 32px;
      }
    }
  }
  .bt-icon {
    overflow: hidden;
    padding-top: 32px;
    flex: 1;
    .twi {
      text-align: right;
      // margin-bottom: 60px;
      & > img {
        width: 48px;
        margin-left: 16px;
      }
    }
    .bt-logo {
      float: right;
      .m-logo {
        width: 80px;
        vertical-align: middle;
        margin-right: 5px;
      }
      .m-logo-name {
        color: #fff;
        font-size: 32px;
        margin-left: -20px;
      }
    }
  }
}
</style>
